// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reconciliation-grid .ag-cell {
    display: flex;
    align-items: center;
  }
 /* roaster.css */

.reconciliation-grid .ag-paging-panel {
    justify-content: flex-end !important; /* Align to the left */
    font-size: 14px;
    padding: 16px 20px; /* More spacious padding */
    background-color: #f9f9f9; /* Optional: soft background */
    border-top: 1px solid #e0e0e0;
    gap: 12px;
  }
  
  .reconciliation-grid .ag-paging-panel > * {
    margin: 0 6px;
  }
  
  .reconciliation-grid .ag-paging-button {
    padding: 6px 12px;
    font-weight: 500;
    border: none;
    background-color: #ffffff;
    border-radius: 6px;
    transition: background-color 0.2s ease;
    cursor: pointer;
    color: #333;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
  
  .reconciliation-grid .ag-paging-button:hover:not(.ag-disabled) {
    background-color: #efefef;
  }
  
  .reconciliation-grid .ag-disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  
  .reconciliation-grid .ag-root-wrapper {
    border: 1px solid #ccc;
    border-radius: 8px;
  }
  
  .reconciliation-grid .ag-paging-row-summary-panel {
    font-weight: 500;
    margin-left: 12px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/reconciliation/roaster.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;EACrB;CACD,gBAAgB;;AAEjB;IACI,oCAAoC,EAAE,sBAAsB;IAC5D,eAAe;IACf,kBAAkB,EAAE,0BAA0B;IAC9C,yBAAyB,EAAE,8BAA8B;IACzD,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,WAAW;IACX,yCAAyC;EAC3C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB","sourcesContent":[".reconciliation-grid .ag-cell {\n    display: flex;\n    align-items: center;\n  }\n /* roaster.css */\n\n.reconciliation-grid .ag-paging-panel {\n    justify-content: flex-end !important; /* Align to the left */\n    font-size: 14px;\n    padding: 16px 20px; /* More spacious padding */\n    background-color: #f9f9f9; /* Optional: soft background */\n    border-top: 1px solid #e0e0e0;\n    gap: 12px;\n  }\n  \n  .reconciliation-grid .ag-paging-panel > * {\n    margin: 0 6px;\n  }\n  \n  .reconciliation-grid .ag-paging-button {\n    padding: 6px 12px;\n    font-weight: 500;\n    border: none;\n    background-color: #ffffff;\n    border-radius: 6px;\n    transition: background-color 0.2s ease;\n    cursor: pointer;\n    color: #333;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  }\n  \n  .reconciliation-grid .ag-paging-button:hover:not(.ag-disabled) {\n    background-color: #efefef;\n  }\n  \n  .reconciliation-grid .ag-disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n  \n  .reconciliation-grid .ag-root-wrapper {\n    border: 1px solid #ccc;\n    border-radius: 8px;\n  }\n  \n  .reconciliation-grid .ag-paging-row-summary-panel {\n    font-weight: 500;\n    margin-left: 12px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
